module.exports = __webpack_public_path__ + "img/Signout.385042bf.svg";